
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/delivery-information/carrier-tracking",
      function () {
        return require("private-next-pages/delivery-information/carrier-tracking/index.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/delivery-information/carrier-tracking"])
      });
    }
  